import actionTypes from './actionTypes';

const reducer = (state = [], action) => {
    // When we request data, we will set state back to [] so loading icon will be displayed
    if (action.type === actionTypes.REQUEST_GLOSSARY) {
        return [];
    }
    if (action.type === actionTypes.GLOSSARY_RESPONSE && action.payload.success) {
        return action.payload.response;
    }
    return state;
};

export default reducer;
